import type {Context} from '../types';

// Legacy support: Form 'dropdown' has been renamed to 'select'.
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}, tag} = jsonNode;
  const formType = data.form && data.form.type;

  return {
    needed: tag === 'select' && formType === 'dropdown',
    logData: {
      msg: 'Dropdown with data.form.type set to "dropdown"',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.form.type = 'select';
    },
  };
};
